import en from './translations/en.json'
import fr from './translations/fr.json'
import es from './translations/es.json'

export default {
    en, fr, es
}